// @flow
import React, { Component } from 'react';

import ContentBox from '../ContentBox.jsx';
import PageHeader from '../PageHeader.jsx';
import DrugTable from './DrugTable.jsx';

class ExpirationReportPage extends Component<{}> {
  render() {
    return (
      <div>
        <PageHeader title="Expiration Report" />
        <ContentBox id="expired" title="Expired">
          <DrugTable category='expired' />
        </ContentBox>
        <ContentBox id="expiring" title="Expiring (within 30 days)">
          <DrugTable category='expiring' />
        </ContentBox>
      </div>
    );
  }
}

export default ExpirationReportPage;



// WEBPACK FOOTER //
// ./client/src/components/pharmacyPages/ExpirationReportPage.jsx